// export const BASE_URL = "http://192.168.0.4:4049";
export const BASE_URL = "https://companyadmin.fractalselite.com";

export const API_ENDPOINT_PATH="/api/v1/user";

